var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wangeditor"}},[_c('div',{staticStyle:{"width":"650px"},attrs:{"id":"editorElem"}})])}]

export { render, staticRenderFns }